import { styled } from 'styled-components';

import {
  searchJobHitTransparentWhenBorderHiddenVar,
  searchJobHitZeroWhenPostedDateHiddenVar,
} from 'modules/search/components/JobHit/searchJobHitCssVariables';
import { bodyMicroText, colors, cssBreakpoints, transition } from 'theme/theme';

export const SearchJobHitFooterHolder = styled.div`
  padding-top: 10px;
  border-top: 1px solid
    var(${searchJobHitTransparentWhenBorderHiddenVar}, ${colors.calloutGrey});
  font-size: 12px;
  position: relative;
  transition: ${transition};
  transition-property: border-top-color;

  @media all and (min-width: ${cssBreakpoints.mdUp}) {
    font-size: 14px;
  }
`;

export const SearchJobHitFooterContent = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  gap: 10px;
`;

export const SearchJobHitFooterPublishedTimeago = styled.span`
  color: ${colors.lightContentGrey};
  ${bodyMicroText};
  line-height: 1;
  transition: ${transition};
  transition-property: opacity;
  opacity: var(${searchJobHitZeroWhenPostedDateHiddenVar}, 1);
`;
